<template>
	<div class="ConfigGenForm" >

		<p>Please enter the following details in order to generate the configuration file.</p>

		<div class="divider"></div>

		<SimpleForm
			submitText="Generate"
			:onSubmit="onSubmit"
			:fields="fields"
			:model="form_vals"
		/>

	</div>
</template>

<script>

	import SimpleForm from '../components/SimpleForm';
	import Variables from '../utils/Variables';

	export default {

		components : {
			SimpleForm,
		},

		props : ['value','variables'],

		data(){
			return {
				form_vals : {},
				sent_vals : {},
			}
		},

		computed:{
			fields : function(){
				var self = this;
				return this.variables.map(function(p){
					return Variables.renderField(p);
				}).filter((e)=>e);
			},
		},

		beforeMount(){
			this.form_vals = this.value || {};
		},

		methods:{
			calcFieldType(variable){
				switch(variable.type){
					case 'integer': return 'number';
					case 'textarea': return 'textarea';
					default: return 'text';
				}
			},
			onSubmit(payload){
				var self = this;
				return new Promise(function(resolve,reject){
					self.$emit('input',Object.assign({},payload));
					resolve(payload);
				});
			}
		}
	}

</script>